module.exports = __webpack_public_path__ + "media/images/next-456b03b7c46851525715123571ac6390.gif";